import React from 'react'
import { MonitorWindow } from '../../../blocks.simple/monitorWindow/MonitorWindow'
import type { MonitorWindowData } from '../../../blocks.simple/monitorWindow/MonitorWindow.types'

export const LogService = ({ data, isMobile }: { data: MonitorWindowData | null; isMobile?: boolean }) => {
    if (!data) return null

    return <MonitorWindow data={data} isMobile={isMobile} />
}
